import React from "react";
import { Box } from "@mui/material";
import logo from "../assets/logo.png";

export function LogoHeader() {
  return (
    <Box sx={{ mt: 8 }}>
      <img alt="seed leaf logo" src={logo} style={{ width: "100%" }} />
    </Box>
  );
}
